import { Directive, Input, ElementRef, Renderer2, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { IconParametersService } from '../services/icon-parameters.service';
import { IconWeight } from './icon-weight.enum';

export interface NimbusIcon {
  icon: string;

  weight: IconWeight;
}

@Directive({
  selector: '[nimbusIcon]',
  standalone: false,
})
export class NimbusIconDirective implements OnInit, OnChanges {
  public iconName: string;

  @Input() public iconWeight: IconWeight;
  @Input() public marked: boolean = false;

  @Input()
  public set nimbusIcon(value: string | NimbusIcon) {
    if (value) {
      if (value.constructor.name === 'String') {
        this.iconName = value as string;
      } else {
        this.iconName = (value as NimbusIcon).icon;
        this.iconWeight = (value as NimbusIcon).weight;
      }
    } else {
      this.iconName = null;
    }
  }

  private renderedClasses: Array<string>;

  private readonly markClass: string = 'icon-marked';

  public constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
    private readonly iconParametersService: IconParametersService,
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.nimbusIcon || changes.marked) {
      this.render();
    }
  }

  public ngOnInit(): void {
    this.render();
  }

  public render() {
    this.reset();
    if (!this.iconWeight) {
      this.iconWeight = IconWeight.Light;
    }

    const { baseClass, iconClass } = this.iconParametersService.getIconParameters(this.iconName, this.iconWeight);

    this.renderer.addClass(this.el.nativeElement, baseClass);
    this.renderer.addClass(this.el.nativeElement, iconClass);
    this.renderedClasses = [baseClass, iconClass];

    if (this.marked) {
      this.renderer.addClass(this.el.nativeElement, this.markClass);
      this.renderedClasses.push(this.markClass);
    }
  }

  public reset() {
    if (this.renderedClasses && this.renderedClasses.length > 0) {
      this.renderedClasses.forEach((styleClass) => this.renderer.removeClass(this.el.nativeElement, styleClass));
      this.renderedClasses = [];
    }
  }
}
